import React from 'react';
import ReactDOM from 'react-dom/client';  // Use the new createRoot API in React 18
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
